import { KnowledgeBaseManager } from "@/components/project/knowledge-base-manager";
import { useIsMobile } from "@/hooks/use-mobile";
import { DesktopOnlyNotice } from "./mobile/desktop-only-notice";
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function KnowledgeBasePage() {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <DesktopOnlyNotice
        title="Wissensdatenbank"
        description="Die Wissensdatenbank und Systemeinstellungen pflegst du am bequemsten am Computer. Bitte am Desktop öffnen."
      />
    );
  }
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-2">
          <Link href="/dashboard">
            <Button variant="ghost" size="sm" className="text-gray-500 hover:text-bauwerk-teal -ml-2">
              <ArrowLeft className="w-4 h-4 mr-1" /> Dashboard
            </Button>
          </Link>
        </div>
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Wissensdatenbank & Einstellungen
          </h1>
          <p className="text-gray-600">
            Verwalten Sie Fachwissen, API-Keys und Systemeinstellungen für die KI-Analyse
          </p>
        </div>
        
        <KnowledgeBaseManager />
      </div>
    </div>
  );
}